export default __webpack_public_path__ + "static/media/bkg--masterplan.aec7db5e.jpg";